import { useTranslation } from 'react-i18next';
import ReactApexChart from 'react-apexcharts';
import { useSetState } from 'react-use';
import MainCard from './MainCard';

import { Grid, Typography } from '@ts/storybook';
import _ from 'lodash';

const GroupedStackedColumns = props => {
  const { t } = useTranslation();

  const [state, setState] = useSetState({
    series: [
      {
        name: 'Actuals in production zone',
        group: 'budget',
        data: [44000, 55000, 41000, 67000, 22000, 43000],
      },
      {
        name: 'Contracted',
        group: 'actual',
        data: [48000, 50000, 40000, 65000, 25000, 40000],
      },
      {
        name: 'Actuals in non productive zones',
        group: 'budget',
        data: [13000, 36000, 20000, 8000, 13000, 27000],
      },
      {
        name: 'Assigned not contracted',
        group: 'actual',
        data: [90, 0, 0, 100, 1200, 2800],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
      },
      stroke: {
        width: 1,
        colors: ['#fff'],
      },
      dataLabels: {
        formatter: val => {
          return val / 1000 + 'K';
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
      xaxis: {
        categories: ['Contractor A', 'Contractor B', 'Contractor C', 'Trucks', 'Archirodon staff', 'Others'],
      },
      fill: {
        opacity: 1,
      },
      colors: ['#80c7fd', '#008FFB', '#80f1cb', '#00E396'],
      yaxis: {
        labels: {
          formatter: val => {
            return val / 1000 + 'K';
          },
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
      },
    },
  });

  return (
    <MainCard contentSX={{ p: 2.25 }}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid mb={1.5}>{props.title && <Typography variant="h5" fontWeight="500" color="primary" text={props.title} />}</Grid>
      </Grid>
      <div className="overflow-auto relative">
        <div className="min-w-full min-h-[502px]">
          {/* @ts-ignore */}
          <ReactApexChart options={state.options} series={state.series} type="bar" height={470} />
        </div>
      </div>
    </MainCard>
  );
};

export default GroupedStackedColumns;
